module.exports = __webpack_public_path__ + "img/alex_feedback_grey.591a2f28.svg";